module.exports = {
      id: "close-usage",
      viewBox: "0 0 14 14.001",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#close",
      toString: function () {
        return this.url;
      }
    }